import React from "react";
import { Button, Tooltip } from "antd";

export default function CardsView({
  cardSort,
  setCardSort,
  cardFilters,
  toggleCardFilter,
  clearAllCardFilters,
  cardSortedData,
  getHasDirectorship,
  handleRowClick,
  handleExportToExcel,
}) {
  return (
    <>
      <div className="sort-bar">
        <div className="filter-chips">
          <span className="chip-filter ">Sorting</span>
          <span className={`chip-filter ${cardSort === "default" ? "active" : ""}`} onClick={() => setCardSort("default")}>
            Default
          </span>
          <span className={`chip-filter ${cardSort === "name" ? "active" : ""}`} onClick={() => setCardSort("name")}>
            Name
          </span>
          <span className={`chip-filter ${cardSort === "ward" ? "active" : ""}`} onClick={() => setCardSort("ward")}>
            Ward
          </span>
          <span className={`chip-filter ${cardSort === "dha" ? "active" : ""}`} onClick={() => setCardSort("dha")}>
            DHA
          </span>
          <span className={`chip-filter ${cardSort === "deceased" ? "active" : ""}`} onClick={() => setCardSort("deceased")}>
            Deceased
          </span>
        </div>
      </div>
      <div className="filter-chips">
        <span className="chip-filter ">Filters</span>
        <span
          className={`chip-filter ${cardFilters.idnoMatchStatus?.includes("Matched") ? "active" : ""}`}
          onClick={() => toggleCardFilter("idnoMatchStatus", "Matched")}
        >
          DHA: Matched
        </span>
        <span
          className={`chip-filter ${cardFilters.idnoMatchStatus?.includes("Not Matched") ? "active" : ""}`}
          onClick={() => toggleCardFilter("idnoMatchStatus", "Not Matched")}
        >
          DHA: Not Matched
        </span>
        <span
          className={`chip-filter ${cardFilters.deceasedStatus?.includes("Alive") ? "active" : ""}`}
          onClick={() => toggleCardFilter("deceasedStatus", "Alive")}
        >
          Alive
        </span>
        <span
          className={`chip-filter ${cardFilters.deceasedStatus?.includes("Deceased") ? "active" : ""}`}
          onClick={() => toggleCardFilter("deceasedStatus", "Deceased")}
        >
          Deceased
        </span>
        <span
          className={`chip-filter ${cardFilters.maritalStatus?.includes("MARRIED") ? "active" : ""}`}
          onClick={() => toggleCardFilter("maritalStatus", "MARRIED")}
        >
          Married
        </span>
        <span
          className={`chip-filter ${cardFilters.maritalStatus?.includes("SINGLE") ? "active" : ""}`}
          onClick={() => toggleCardFilter("maritalStatus", "SINGLE")}
        >
          Single
        </span>
        <span
          className={`chip-filter ${cardFilters.maritalStatus?.includes("DIVORCED") ? "active" : ""}`}
          onClick={() => toggleCardFilter("maritalStatus", "DIVORCED")}
        >
          Divorced
        </span>
        <span
          className={`chip-filter ${cardFilters.maritalStatus?.includes("WIDOWED") ? "active" : ""}`}
          onClick={() => toggleCardFilter("maritalStatus", "WIDOWED")}
        >
          Widowed
        </span>
        <span
          className={`chip-filter ${cardFilters.gender?.includes("Male") ? "active" : ""}`}
          onClick={() => toggleCardFilter("gender", "Male")}
        >
          Male
        </span>
        <span
          className={`chip-filter ${cardFilters.gender?.includes("Female") ? "active" : ""}`}
          onClick={() => toggleCardFilter("gender", "Female")}
        >
          Female
        </span>
        <span
          className={`chip-filter ${cardFilters.hasDirectorship?.includes("Yes") ? "active" : ""}`}
          onClick={() => toggleCardFilter("hasDirectorship", "Yes")}
        >
          Directorship: Yes
        </span>
        <span
          className={`chip-filter ${cardFilters.hasDirectorship?.includes("No") ? "active" : ""}`}
          onClick={() => toggleCardFilter("hasDirectorship", "No")}
        >
          Directorship: No
        </span>
        {Object.keys(cardFilters).length > 0 && (
          <span className="chip-filter clear" onClick={clearAllCardFilters}>
            Clear
          </span>
        )}
      </div>
      <div className="indigent-grid" style={{ marginTop: 20 }}>
        {cardSortedData.map((item, idx) => {
          const initials = ((item.firstNames?.[0] || "") + (item.surName?.[0] || "")).trim().toUpperCase() || "∎";
          return (
            <div key={item.id || idx} className="indigent-card">
              <div className="indigent-head">
                <div className="indigent-avatar">{initials[0]}</div>
                <div>
                  <div className="indigent-name">{`${item.firstNames || ""} ${item.surName || ""}`.trim() || "Unknown"}</div>
                  <div className="indigent-meta">
                    {item.idNumber || "No ID"} · {item.wardNumber ? `Ward ${item.wardNumber}` : "No Ward"}
                  </div>
                </div>
              </div>
              <div className="indigent-tags">
                <span className="chip dark">DHA: {item.idnoMatchStatus || "-"}</span>
                <span className="chip dark">Deceased: {item.deceasedStatus || "-"}</span>
                <span className="chip dark">Marital: {item.maritalStatus || "-"}</span>
                <span className="chip dark">Gender: {item.gender || "-"}</span>
                <span className="chip dark">Directorship: {getHasDirectorship(item)}</span>
              </div>
              <div className="indigent-actions">
                <Button type="default" className="btn-ghost btn-lux" onClick={() => handleRowClick(item)}>
                  Open
                </Button>
                <Tooltip title="Export single row">
                  <Button type="default" className="btn-ghost btn-lux" onClick={() => handleExportToExcel([item])}>
                    Export
                  </Button>
                </Tooltip>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
